module.exports = __webpack_public_path__ + "img/lazer.b4f75448.svg";